module.exports = __webpack_public_path__ + "static/team_waves-db80cb168ae37d61020f5ee4337e17c9.svg";